<template>
  <div class="col-12 flex justify-center mt3 flex-column">
    <div class="flex items-center justify-center">
      <img :src="imagePath('icons/yellow-arrow-icon.svg')" class="mr2" alt="icon-yellow-arrow" width="26" height="26">
      <span class="center bold violet h3">Bien joué!</span>
    </div>

    <div :style="{ '--cust-border-color': 'light-cyan', '--cust-border-radius': '0px' }" class="cust-border p2 light-cyan-bg mt2 h6 center">
      {{ sessionMessageLabel }}
    </div>

    <div v-if="!isInvite" class="mt2 h6 center">
      <span class="bold">Invite tes coéquipiers à rejoindre la partie ! </span>
      <span>Ils pourront s'inscrire et payer leur part en un clic.</span>
    </div>

    <div class="mt2">
      <Button
        v-if="!isInvite"
        class="col-12"
        :action="() => shareSession()"
        color="violet-bg"
        text-size="h6"
        text="Partager la partie"
      />
      <h4 v-if="showMessageUrl" class="h6 green">Lien copié dans le presse-papiers</h4>
      <Button
        class="col-12 mt2"
        :action="() => reddirectToPersonalSpace()"
        color="violet"
        border="violet-bd"
        text="Accéder à mon espace perso"
      />

      <p class="h6 center">
        Tu vas recevoir par mail la confirmation de ta
        réservation et ton QRcode d'accès au terrain.
        Retrouve toutes les infos dans ton espace
        personnel.
      </p>
    </div>
  </div>
</template>

<script setup>

import { computed, ref, onBeforeMount } from 'vue';
import { useRoute } from 'vue-router';
import { frenchTime, assetsPath } from '@/utils/utils';
import { computeCourtDataLayer } from '@/utils/index';

import { useStore } from '@/store/index';

import Button from '@/components/elements/Button';

const store = useStore();
const route = useRoute();

const showMessageUrl = ref(false);

const siteInfo = computed(() => store.state.siteInfo);
const product = computed(() => store.state.product);
const offerInfo = computed(() => store.state.offerInfo);

const session = computed(() => store.state.courtSettings.session);

const isInvite = computed(() => store.state.courtSettings.isInvite);
const canShare = computed(() => typeof navigator !== 'undefined' && !!navigator.share);

const sessionDateShort = computed(() => {
  const sessionEndTime = frenchTime(session.value.end_date, ' à HH:mm', siteInfo.value.timezone);
  return frenchTime(session.value.start_date, "EEEE dd MMMM 'de' HH:mm", siteInfo.value.timezone) + sessionEndTime;
});

// TODO: Remove default
const captain = computed(() => store.state.courtSettings?.session?.captain);

const sessionMessageLabel = computed(() => {
  if (isInvite.value) {
    return `Tu as rejoint l'équipe de ${captain.value.firstname} pour une partie de ${offerInfo.value.filliere}, ${sessionDateShort.value}, ${session.value.detail.name}`;
  }
  return `Tu as réservé une partie de ${offerInfo.value.filliere}, ${sessionDateShort.value}, ${session.value.detail.name}`;
});

const reddirectToPersonalSpace = () => {
  computeCourtDataLayer('reddirectToPersonalSpace', { ...store.state.courtSettings }, route.fullPath, { ...store.state.product }, { ...store.state.offerInfo });

  const baseUrl = `${process.env.VUE_APP_UCPA_DOMAIN}/${siteInfo.value.site_preroute}/espacepersonnel/${siteInfo.value.site_url}`;
  const impersonateToken = store.state.impersonateData;

  if (impersonateToken) {
    window.location.href = `${baseUrl}?impersonateData=${impersonateToken}`;
    return;
  }

  window.location.href = baseUrl;
};

const copyToClipBoard = async url => {
  try {
    await navigator.clipboard.writeText(url);
    showMessageUrl.value = true;
  } catch (err) {
    console.error('Failed to copy URL to clipboard:', err);
  }
};

const shareSession = async () => {
  computeCourtDataLayer('shareSession', { ...store.state.courtSettings }, route.fullPath, { ...store.state.product }, { ...store.state.offerInfo });

  const url = `${process.env.VUE_APP_UCPA_DOMAIN}/loisirs-reservation?workspace=${siteInfo.value.workspace}&product=${product.value.uuid}&offer=${offerInfo.value.horanet_product.horanet_product_code}&session=${session.value?.code || session.value.id}`;

  const shareData = {
    title: 'UCPA',
    text: 'Partager la partie',
    url: url
  };

  if (!canShare.value) {
    await copyToClipBoard(url);
    return;
  }

  try {
    await navigator.share(shareData);
  } catch (err) {
    if (err?.message !== 'Share canceled') {
      await copyToClipBoard(url);
    }
  }
};

onBeforeMount(() => {
  computeCourtDataLayer('CourtConfirmation', { ...store.state.courtSettings }, route.fullPath, { ...store.state.product }, { ...store.state.offerInfo }, { ...store.state.user });
});

const imagePath = name => `${assetsPath()}img/${name}`;

</script>

<style scoped>

</style>
